import { message, Modal } from 'antd'
import { change } from 'redux-form'
import { expireRamsRecord } from '../../../../../HttpRequests/ramsRecords'
import fetchRamsRecords from '../../../../../Screens/ProjectView/Services/fetchRamsRecords'
import { FORM_NAME } from '../../../Form'
import _props from '../../../props'

export default () => (dispatch) => {

  const { ramsRecordId } = _props.get()

  if (!ramsRecordId) {
    message.warning('Please save the RAMS record first.')
    return
  }

  Modal.confirm({
    title: 'Expire RAMS Record',
    content: 'Are you sure you want to expire this RAMS record? This action cannot be undone.',
    okText: 'Expire',
    okType: 'danger',
    onOk: async () => {
      try {
        await expireRamsRecord(ramsRecordId)
        dispatch(change(FORM_NAME, 'status', 'expired'))
        dispatch(fetchRamsRecords())
        message.success('RAMS record has been expired.')
        _props.get().onClose()
      } catch (error) {
        const msg = error.response && error.response.data && error.response.data.error
          ? error.response.data.error
          : 'Failed to expire RAMS record'
        message.error(msg)
      }
    },
  })

}
